import React from 'react';
import { TextInput } from './TextInput';
import { RecordSelectInput } from './RecordSelectInput';
import * as Grid from '../components/Grid';
export const AddressFields = ({ idBase, address, states, onChange, errors, }) => {
    const onAddressChange = (name, value) => {
        onChange({
            ...address,
            [name]: value,
        });
    };
    return (React.createElement("div", { id: idBase },
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: 12, lg: 8 },
                React.createElement(TextInput, { label: "Address 1", id: `${idBase}_address1`, required: true, errors: errors, value: address.address1, onChange: (v) => onAddressChange('address1', v) })),
            React.createElement(Grid.Column, { width: 12, lg: 4 },
                React.createElement(TextInput, { label: "Address 2", id: `${idBase}_address2`, value: address.address2, onChange: (v) => onAddressChange('address2', v) })),
            React.createElement(Grid.Column, { width: 12, lg: 5 },
                React.createElement(TextInput, { label: "City", id: `${idBase}_city`, required: true, errors: errors, value: address.city, onChange: (v) => onAddressChange('city', v) })),
            React.createElement(Grid.Column, { width: 6, lg: 4 },
                React.createElement(RecordSelectInput, { label: "State", id: `${idBase}_state`, value: address.state_id, options: states, required: true, errors: errors, onChange: (v) => onAddressChange('state_id', v) })),
            React.createElement(Grid.Column, { width: 6, lg: 3 },
                React.createElement(TextInput, { label: "Zip", id: `${idBase}_zip`, required: true, errors: errors, value: address.zip, onChange: (v) => onAddressChange('zip', v) })))));
};
